import { render, staticRenderFns } from "./dialogDetailOnlyType1.vue?vue&type=template&id=6361f995&scoped=true"
import script from "./dialogDetailOnlyType1.vue?vue&type=script&lang=js"
export * from "./dialogDetailOnlyType1.vue?vue&type=script&lang=js"
import style0 from "./dialogDetailOnlyType1.vue?vue&type=style&index=0&id=6361f995&prod&lang=scss&scoped=true"
import style1 from "./dialogDetailOnlyType1.vue?vue&type=style&index=1&id=6361f995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361f995",
  null
  
)

export default component.exports